import React, {Component} from "react";
import {Button, Col, Form, Modal, Row} from "react-bootstrap";
import {storeRetirementType,} from "../../../services/RequestService";

class ModalRetirementType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: props?.name ?? "",
      description: props?.description ?? "",
      isDescriptionValid: undefined
    };
  }

  handleInputChange = (e) => {
    e.persist();
    const { name, value } = e.target;
    this.setState((state) => ({ ...state, [name]: value }));
  };

  isDescriptionValid = () => {
    const { description } = this.state;
    let isDescriptionValid = description !== "";
    this.setState((state) => ({ ...state, isDescriptionValid }));
  };

  submit = (_) => {
    const { description } = this.state;
    const { id } = this.props;
    storeRetirementType({ id, description }).then((res) => {
      if (res.ok) {
        this.props.onHide(true);
      }
    });
  };

  isBtnDisabled = () => {
    return !this.state.description;
  };

  render() {
    const {
      description,
      isDescriptionValid,
    } = this.state;
    const { show, onHide, id } = this.props;

    return (
      <Modal show={show} onHide={onHide} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>Adicionar Tipo de Aposentadoria</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Row>
            <Form.Group as={Col}>
              <Form.Label>Descrição</Form.Label>
              <Form.Control
                as="textarea"
                name="description"
                value={description}
                onChange={this.handleInputChange}
                onBlur={this.isDescriptionValid}
                rows={10}
                className={
                  isDescriptionValid === undefined
                    ? ""
                    : isDescriptionValid
                    ? "is-valid"
                    : "is-invalid"
                }
              />
              <Form.Text className="is-required">
                {isDescriptionValid === undefined
                  ? ""
                  : isDescriptionValid
                  ? ""
                  : "O campo descrição não pode ser vazio"}
              </Form.Text>
            </Form.Group>
          </Form.Row>
        </Modal.Body>
        <Modal.Footer className="p-0">
          <Row className="w-100 m-0">
            <Button
              variant="primary"
              className="w-100 button-without-rounded"
              disabled={this.isBtnDisabled()}
              onClick={this.submit}
            >
              {id === null ? "Cadastrar" : "Atualizar"}
            </Button>
          </Row>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ModalRetirementType;
